import { useEffect } from 'react';
import { CheckCircle, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Success() {
  useEffect(() => {
    // Track conversion in Google Analytics
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17620388526/purchase',
        'value': 1250.00,
        'currency': 'USD'
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-lg p-8 sm:p-12 text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-3xl sm:text-4xl font-black text-[#1c334a] mb-4">
          Payment Successful!
        </h1>
        
        <p className="text-lg text-[#526981] mb-8">
          Thank you for securing your spot in the AI Opportunity Audit. Your $1,250 deposit has been processed successfully.
        </p>

        {/* What's Next */}
        <div className="bg-[#f8f9fa] rounded-2xl p-6 mb-8 text-left">
          <h2 className="text-xl font-bold text-[#1c334a] mb-4">What Happens Next:</h2>
          <ul className="space-y-3 text-[#526981]">
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-[#049aaa] flex-shrink-0 mt-0.5" />
              <span>You'll receive a confirmation email within 5 minutes with your receipt</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-[#049aaa] flex-shrink-0 mt-0.5" />
              <span>Our team will contact you within 24 hours to schedule your kickoff session</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-[#049aaa] flex-shrink-0 mt-0.5" />
              <span>Your audit will begin within the next two weeks</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-[#049aaa] flex-shrink-0 mt-0.5" />
              <span>Final payment ($1,250) will be due upon audit delivery</span>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-200 pt-6">
          <p className="text-sm text-[#526981] mb-4">
            Questions about your audit? Contact us:
          </p>
          <a 
            href="mailto:info@trilogyoneconsulting.com"
            className="inline-flex items-center gap-2 text-[#049aaa] hover:text-[#0fb6c1] font-medium"
          >
            <Mail className="w-4 h-4" />
            info@trilogyoneconsulting.com
          </a>
        </div>

        {/* Back to Home */}
        <div className="mt-8">
          <Button
            onClick={() => window.location.href = 'https://trilogyoneconsulting.com'}
            className="bg-[#d8e005] text-[#1c334a] hover:bg-transparent hover:text-[#1c334a] hover:border-2 hover:border-[#d8e005] rounded-2xl px-8 py-3 font-black transition-all"
          >
            Return to Trilogy One Website
          </Button>
        </div>

        {/* Trilogy One Logo */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <img
            src="https://customer-assets.emergentagent.com/job_b7df7e6c-e242-4f3e-81af-66fcd6ed0832/artifacts/z3oe8tks_Trilogy%20One%20Logo%20.png"
            alt="Trilogy One Logo"
            className="h-8 mx-auto opacity-50"
          />
        </div>
      </div>
    </div>
  );
}
